module.exports = __webpack_public_path__ + "2e1105d08166907c70311019baff75aa.svg";